import React from 'react';

interface FieldErrorProps {
  error?: string;
}

/**
 * Inline validation error display above a form field.
 * Shows a red error message when present, nothing when undefined.
 *
 * Usage:
 *   <FieldError error={getFieldError('fc110_12')} />
 *   <Input value={...} />
 */
const FieldError: React.FC<FieldErrorProps> = ({ error }) => {
  if (!error) return null;
  return (
    <div style={{ color: '#ff4d4f', fontSize: 12, lineHeight: '18px', marginBottom: 2 }}>
      {error}
    </div>
  );
};

export default React.memo(FieldError);
